<script>
	import { hero_expanded } from './../stores.js'

  const quotes = [
    {author: 'Paula Scher', quote: 'Words have meaning. Type has spirit. The combination is spectacular.'},
    {author: 'Bonnie Siegler', quote: 'Your choice of typeface is as important as what you do with it.'},
    {author: 'Matthew Carter', quote: 'Type is a beautiful group of letters, not a group of beautiful letters.'},
    {author: 'R. Roger Remington', quote: 'Form and function together create typographic excellence.'},
    {author: 'Beatrice Warde', quote: 'There are bad types and good types, typography begins after the first category has been set aside.'},
    {author: 'Gerard Unger', quote: 'It is almost impossible to look and read at the same time: they are different actions.'},
  ]

  const random_quote = quotes[Math.floor(Math.random() * quotes.length)]
  // const random_quote = quotes[4]
</script>

{#if $hero_expanded}
  <div class="TypeQuotes">
    <h2>&ldquo;{@html random_quote.quote}&rdquo;</h2>
    <span>&mdash;{random_quote.author}</span>
  </div>
{/if}

<style>
  .TypeQuotes {
    position: absolute;
    top: 18vh;
    width: 60vw;
  }
  .TypeQuotes h2 {
    margin-bottom: 1rem;
    text-indent: -0.5em;
    font-family: var(--PensumDisplay);
    font-size: calc(1.6vh + 1.8vw);
    line-height: 1.2em;
    letter-spacing: 0.05rem;
    color: var(--c-quotes-on-fill);
  }
  .TypeQuotes span {
    font-family: var(--PensumSans);
    font-size: 2.3rem;
    color: var(--c-text-faded);
  }
</style>